import { render } from "./GoogleSearch.vue?vue&type=template&id=30643629"
import script from "./GoogleSearch.vue?vue&type=script&lang=js"
export * from "./GoogleSearch.vue?vue&type=script&lang=js"

import "./GoogleSearch.vue?vue&type=style&index=0&id=30643629&lang=scss"

import exportComponent from "/codebuild/output/src76281229/src/git-codecommit.us-east-1.amazonaws.com/v1/repos/www-uga-edu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__